import { render } from "./Edit.vue?vue&type=template&id=58c8567a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksStatusesTypes/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58c8567a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58c8567a', __exports__)) {
    api.reload('58c8567a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=58c8567a", () => {
    api.rerender('58c8567a', render)
  })

}


export default __exports__